import type { FullStoryVars, EventProperties } from './types';

/* Identify user to fullstory.
 * @param uid - unique identifer of current user
 * @param userVars - Json dictionary. (As a practice we submit email, displayName, and user.group.featureFlags if defined)
 * @remarks Can only be called once. You can't re-identify someone.
 * @see {@link https://help.fullstory.com/hc/en-us/articles/360020828113-FS-identify-Identifying-users|FS.identify - Identifying users}
 */
export const fullstoryIdentify = (
  uid: string,
  userVars: FullStoryVars,
): void => {
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.FS && window.FS.identify(uid, userVars);
};

/* Log a message to fullstory without logging to developer console
 * @param message - string
 * @see {@link https://developer.fullstory.com/browser/auto-capture/logging/ - Logging}
 */
export const fullstoryLog = (message: string): void => {
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.FS && window.FS.log(message);
};

/* Log info message to fullstory without logging to developer console
 * @param message - string
 * @see {@link https://developer.fullstory.com/browser/auto-capture/logging/ - Logging}
 */
export const fullstoryInfo = (message: string): void => {
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.FS && window.FS.log('info', message);
};

/* Log warn message to fullstory without logging to developer console
 * @param message - string
 * @see {@link https://developer.fullstory.com/browser/auto-capture/logging/ - Logging}
 */
export const fullstoryWarn = (message: string): void => {
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.FS && window.FS.log('warn', message);
};

/* Log error message to fullstory without logging to developer console
 * @param message - string
 * @see {@link https://developer.fullstory.com/browser/auto-capture/logging/ - Logging}
 */
export const fullstoryError = (message: string): void => {
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.FS && window.FS.log('error', message);
};

/* Send custom event to event stream sent to fullstory
 * @param eventName - The eventName parameter is a string containing the name of the event. The exact event name will be searchable via FullStory’s OmniSearch capabilities.
 * @param eventProperties - Json object containing additional information about the event. Special formatting of keys is required. See property key and value requirements.
 * @see {@link https://help.fullstory.com/hc/en-us/articles/360020623274-FS-event-API-Sending-custom-event-data-into-FullStory - Fullstory events}
 * @see {@link https://help.fullstory.com/hc/en-us/articles/360020623234-Client-API-Requirements#Custom%20Property%20Name%20Requirements - Property Name Requirements}
 * @see {@link https://help.fullstory.com/hc/en-us/articles/360020623234-Client-API-Requirements#Custom%20Property%20Value%20Requirements - Property Value Requirements}
 */
export const fullstoryEvent = <T extends EventProperties>(
  name: string,
  properties?: T,
): void => {
  //eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  window.FS && window.FS.event(name, properties);
};
